import { useQuery } from "@tanstack/react-query";
import axiosManager from "services/axiosManager";

const useGetStudentStaff = () => {
    const {
        data: studentStaff,
        error,
        isLoading,
    } = useQuery({
        queryKey: ["student staff"],
        queryFn: () =>
            axiosManager.get$("/student/staff").then((res) => res.data),
    });

    return { studentStaff, error, isLoading };
};

export default useGetStudentStaff;
